import { render, staticRenderFns } from "./cartOrderDialog.vue?vue&type=template&id=ed440ca2&scoped=true&"
import script from "./cartOrderDialog.vue?vue&type=script&lang=js&"
export * from "./cartOrderDialog.vue?vue&type=script&lang=js&"
import style0 from "./cartOrderDialog.vue?vue&type=style&index=0&id=ed440ca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed440ca2",
  null
  
)

export default component.exports